<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
body {
  font-family: 'Roboto', sans-serif;
}
.theme--light {
  &.application {
    &:before {
      position: absolute;
      width: 100%;
      height: 250px;
      top: 0;
      left: 0;
      content: '';
      background-color: #007bff;
    }
  }
}
#app {
  position: relative;
  background: url('/static/pattern.png');
  .theme--light {
    .v-text-field--outline {
      .v-input__slot {
        border: 1px solid #bdbdbd;
      }
    }
    .v-text-field--solo {
      .v-input__slot {
        border: 1px solid #bdbdbd;
      }
    }
  }
  .pinCodeForm .field-group {
    .v-input__slot {
      padding: 0;
    }
    input {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 27px;
      font-weight: 900;
    }
  }
  .v-card {
    &__title {
      h2 {
        font-size: 3.4rem;
        font-weight: 700;
        color: #333;
        margin: 0 auto 32px;
        text-align: center;
      }
      h3 {
        font-size: 2.8rem;
        font-weight: 700;
        color: #333;
        margin: 0 auto;
        text-align: center;
      }
    }
    &__text {
      h2 {
        font-size: 3.4rem;
        font-weight: 700;
        color: #000;
        margin: 0 auto 35px;
        text-align: center;
      }
      h4 {
        font-size: 1.8rem;
        font-weight: 700;
        color: #333;
        margin: 0 auto 16px;
        text-align: center;
      }
      .v-form {
        .upperLine {
          display: block;
          font-size: 0.82rem;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 3px;
        }
        .upperLine-error {
          color: #ff5252;
        }
        .has-error {
          .v-input__slot {
            border: 1px solid #ff5252;
            input {
              color: #ff5252;
            }
          }
        }
        .edit-text-field {
          .v-input__slot {
            background-color: #f5f5f5 !important;
          }
        }
      }
      .vue-form-generator {
        fieldset {
          border: 1px solid #ccc;
          background: #fbfbfb;
          border-radius: 5px;
          text-align: left;
          padding: 16px;
          margin: 16px 0;
          .field-wrap {
            input,
            textarea {
              color: #000;
            }
          }
        }
      }
      .success--text {
        color: #007bff !important;
      }
    }
  }
}
@media only screen and (max-width: 600px) {
  #app {
    .v-card {
      &__title {
        h2 {
          font-size: 2.4rem;
          margin: 0 auto 48px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue